module.exports = __webpack_public_path__ + "img/Rovinj.f7706d7b.jpg";